import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useDisclaimer = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const addDisclaimer = async (newData, applyData) => {
    const responseData = await sendRequest({
      url: '/api/v1/disclaimer',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: { ...newData },
    });

    applyData(responseData);
  };

  const getUnseenDisclaimers = () => {
    return new Promise(async (resolve, reject) => {
      const responseData = await sendRequest({
        url: '/api/v1/disclaimer/unseen',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });

      resolve(responseData);
    });
  };

  return {
    isLoading,
    error,
    addDisclaimer,
    getUnseenDisclaimers,
  };
};

export default useDisclaimer;
